import { Assets } from "assets/Assets";
import React, { useState } from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { Dim } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import ProjectItem from "./ProjectItem";
import { MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { UIGalleryItemType } from "features/gallery/types";

interface ProjectProps {
  item: UIGalleryItemType;
}

const Project: React.FC<ProjectProps> = ({ item }) => {
  const [] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/gallery/${encodeURIComponent(item.alias)}`);
  };

  const mainImage = item?.images.find((item) => item.is_main_image === true);

  return (
    <ProjectContainer>
      <ImageContainer onClick={handleClick} img={mainImage}>
        <Dim percent={60} />
        <TextContainer>
          <ImageTitle className="text-md">{item.title}</ImageTitle>
          <MdChevronRight className="title-chevron" />
        </TextContainer>
      </ImageContainer>
      <ProjectItemsContainer>
        <Title>Използвани климатици</Title>
        {item.items.map((item, idx) => {
          return <ProjectItem item={item} key={idx} />;
        })}
      </ProjectItemsContainer>
    </ProjectContainer>
  );
};

const ProjectContainer = styled.div`
  display: flex;
  flex-flow: column;

  & + & {
    margin-top: 25px;
  }

  @media only screen and (${device.laptop}) {
    height: 378px;
    flex-flow: row nowrap;
  }

  @media only screen and (${device.laptopL}) {
    height: 327px;
  }

  @media only screen and (${device.desktop}) {
    height: 357px;
  }
`;

const ImageContainer = styled.div<{ img: any }>`
  background-image: ${(props) =>
    props.img ? `url(data:${props.img.contentType};base64,${props.img.image});` : `url(${Assets.About.install})`};
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 266px;

  @media only screen and (${device.tablet}) {
    height: 276px;
  }

  @media only screen and (${device.laptop}) {
    height: 100%;
    width: 40%;
  }
`;

const TextContainer = styled.div`
  padding: 10px;
  border: 2px solid white;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  position: absolute;
  margin: auto;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  width: 80%;
  transition: 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .title-chevron {
    width: 36px;
    height: 36px;
    color: white;
    margin-left: 5px;
  }
`;

const ImageTitle = styled.span`
  color: white;
  font-weight: bold;
`;

const ProjectItemsContainer = styled.div`
  flex: 1;
  border: 1px solid ${colors.gray};
  padding: 15px 10px;

  overflow-y: scroll;
`;

const Title = styled.p`
  font-weight: bold;
  color: black;
  width: 80%;
`;

export default Project;
